import React from 'react';
import classNames from 'classnames';
import Clipboard from 'clipboard';
import { extend } from 'lodash';
import { Text } from 'pp-react';

import * as analytics from '../lib/analytics';
import HubSocialShare from './HubSocialShare';
import Modal from './Modal';

import styles from './confirmation.less';

import { ModalInputDiv, InputOverlay, InputOverlayMobileWidth } from './styles';

import content from '../lib/i18n';
const i18n = content('hub/components/confirmation');

const ConfirmationModal = React.memo(
  ({ npoUrl, fptiInfo, isMobile, subTitle, title }) => {
    new Clipboard('#clipBoardTrigger');

    const clickCopy = event => {
      analytics.trackLink(
        'overlaycopybutton',
        fptiInfo.pgrp,
        fptiInfo.page,
        'link'
      );
    };

    let inputOverlayStyle = '';

    if (isMobile) {
      inputOverlayStyle = extend({}, InputOverlay, InputOverlayMobileWidth);
    } else {
      inputOverlayStyle = extend({}, InputOverlay);
    }

    const clipBtnStyle = classNames('clipBtn', {
      clipBtnMobile: isMobile,
    });

    return (
      <Modal titleId={i18n('label.confTitle')} showOnMount={true}>
        <>
          <div className={styles['confirmation-container']}>
            <img
              src='https://www.paypalobjects.com/webstatic/en_GB/mktg/ppc/icon-success.png'
              alt='confirmpng'
              height='82'
              width='82'
            />
          </div>
          <Text
            as='h2'
            id={i18n('label.confTitle')}
            size='xl3'
            className={styles['center-text']}
            dangerouslySetInnerHTML={{
              __html: title ? title : i18n('label.confTitle'),
            }}
          />
          <Text
            as='p'
            size='md'
            className={`${styles['center-text']} ${styles['extra-margin']}`}
            dangerouslySetInnerHTML={{
              __html: subTitle ? subTitle : i18n('label.confSubTitle'),
            }}
          />
          <div style={{ textAlign: 'center' }}>
            <Text
              as='p'
              size='md'
              regular
              className={styles['social-invite-text']}
            >
              {i18n('label.confInvite')}
            </Text>
            <div style={ModalInputDiv} className='modalInputDiv'>
              <input
                className='overlay_input'
                style={inputOverlayStyle}
                type='text'
                id='clipBoardTextInput'
                value={npoUrl}
              />
              <button
                href='#'
                id='clipBoardTrigger'
                className={clipBtnStyle}
                data-clipboard-target='#clipBoardTextInput'
                onClick={e => {
                  clickCopy(e);
                }}
              >
                {i18n('label.confCopyButton')}
              </button>
            </div>
            <div className='share' style={{ marginTop: '20px' }}>
              <HubSocialShare url={npoUrl} fptiInfo={fptiInfo} />
            </div>
          </div>
        </>
      </Modal>
    );
  }
);

export default ConfirmationModal;
